// Core imports
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

// Component imports
import { Row, Card, Col, Divider, Form, Input, Button, Switch } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import { RiDeleteBin6Line } from 'react-icons/ri';

// Misc imports
import { GOOGLE_RECAPTCHA_SITE_KEY, PREVIEW_MODES, STORAGE_KEYS } from '../../constants';

const PersonalInformationTab = props => {
  const { wrapperCol, mode, onSubmitSuccess, onStepChange, initialValues, onDelete } = props;

  const location = useLocation();
  const { pathname } = location;
  const [form] = Form.useForm();

  const [, updateState] = useState(); // Hook to force a component re-render

  // TODO: For fields that appear and disappear, make sure to clear the values if needed
  // TODO: Previous step

  // On mount
  useEffect(() => {
    form.resetFields();

    return () => {
      onStepChange(form.getFieldsValue(true));
    };
  }, [pathname]);

  return (
    <Form
      layout="vertical"
      name="personalInformationForm"
      form={form}
      initialValues={initialValues || JSON.parse(window.localStorage.getItem(STORAGE_KEYS.NDE_TO_CREATE)) || {}}
      onFinish={(values) => onSubmitSuccess(values)} // Let parent form group handle saving based on edit/create mode
      onFieldsChange={(_, allFields) => updateState(allFields)}
      scrollToFirstError
    >
      <Row>
        <Col {...wrapperCol}>
          <Row className="mb-16">
            <Col lg={20} span={24} className="mb-24">
              <h3>
                Email
              </h3>
              <p className="p1-body mb-0">
                Personal details, like most other steps are optional. Entering your email here won't show it to anyone unless you choose to.
              </p>
            </Col>

            <Col span={24}>
              <Form.Item
                name="email"
                // TODO: validation
              >
                <Input size="large" placeholder="Enter your email" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Divider className="mt-32 mb-42" />
            </Col>
          </Row>

          <Row>
            <Col lg={20} span={24} className="mb-24">
              <h3>
                Email sharing settings
              </h3>
              <p className="p1-body mb-0">
                Caution! If you choose to let other users contact you, your email will be public!
              </p>
            </Col>

            <Col span={24} className="mb-32">
              <Card className="border-color-black-40">
                <Row justify="space-between" align="middle">
                  <Col>
                    Allow admins to contact me
                  </Col>
                  <Col>
                    <Form.Item name="allowContactByAdmins" valuePropName="checked" className="mb-0">
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            <Col span={24}>
              <Card className="border-color-black-40">
                <Row justify="space-between" align="middle">
                  <Col>
                    Allow other users to contact me
                  </Col>
                  <Col>
                    <Form.Item name="allowContactByUsers" valuePropName="checked" className="mb-0">
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {
        mode === PREVIEW_MODES.CREATE ? (
          <Row className="mt-48">
            <Col>
              <Form.Item
                name="recaptcha"
                rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please complete the reCAPTCHA')) }]}
              >
                <ReCAPTCHA
                  sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                  onChange={value => form.setFieldsValue({ recaptcha: value })}
                />
              </Form.Item>
            </Col>
          </Row>
        ) : null
      }

      {
        mode === PREVIEW_MODES.VIEW ? null : (
          <Row justify={mode === PREVIEW_MODES.EDIT ? 'space-between' : 'end'} align="middle" className="mt-48">
            {
              mode === PREVIEW_MODES.EDIT ? (
                <Col>
                  <Button
                    danger
                    icon={<RiDeleteBin6Line size={14} style={{ marginRight: 4 }} />}
                    onClick={onDelete}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    Delete NDE
                  </Button>
                </Col>
              ) : null
            }
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-black-100 border-color-black-100 hover-bg-black-80 hover-border-color-black-80"
              >
                {
                  mode === PREVIEW_MODES.EDIT ? 'Save' : 'Submit NDE'
                }
              </Button>
            </Col>
          </Row>
        )
      }
    </Form>
  );
};

PersonalInformationTab.propTypes = {
  mode: PropTypes.string,
  wrapperCol: PropTypes.object,
  onSubmitSuccess: PropTypes.func,
  onStepChange: PropTypes.func,
  initialValues: PropTypes.object,
  onDelete: PropTypes.func
};

export default PersonalInformationTab;
